// Page module: the statistics page.

global.statistics = {
  data: {},
  init: function(url) {
    statistics.data.url = url;
    $('[data-provide="datepicker"]').datepicker();
    // Not on changeDate: with a from and a to field, that searched once for a range the
    // user had only half entered. The button is the whole point of a range.
    $('.statistics-search').click(statistics.search);
    setTimeout(statistics.search, 500);
  },
  search: function() {
    var $tableHolderDiv = $('.table-holder');
    var $spinnerDiv = $('.spinner-holder');

    $tableHolderDiv.hide();
    overrides.spinnerAjax($spinnerDiv, statistics.data.url, {
      method: 'GET',
      data: {
        from_date: $('.from-date').val(),
        to_date: $('.to-date').val()
      },
      success: function(data) {
        $('.from-date').val(data.from_date);
        $('.to-date').val(data.to_date);
        $tableHolderDiv.html(data.html);
        $tableHolderDiv.show();
      },
      error: function(e) {
        console.log('error', e);
      }
    });
  }
};
